// Tabs/TabPanelContent_Compounds.tsx
import React from 'react';
import CompoundsTable from '../components/tabs/compounds/CompoundsTable';
import CannabinoidTable from '../components/tabs/compounds/CannabinoidsTable';
import AromaTable from '../components/tabs/compounds/AromaTable';
import PubChemListCard from '../components/tabs/compounds/PubchemList';
import PubChemTableCard from '../components/tabs/compounds/PubchemTable';
import ChemSpiderTableCard from '../components/tabs/compounds/ChemSpiderTable';
import CompoundCard from '../components/tabs/compounds/Compound';
import CannabinoidCard from '../components/tabs/compounds/Cannabinoid';
import AromaCard from '../components/tabs/compounds/Aroma';
import CannabisDBCard from '../components/tabs/compounds/CannabisDB';
import PubchemCard from '../components/tabs/compounds/Pubchem';
import ChemSpiderCard from '../components/tabs/compounds/ChemSpider';
import DynamicTabContentTable from './DynamicTabContentTable';

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentCompounds: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <CompoundsTable header={'Compounds'} eventGroupToTrigger={'compounds'} />
            <CannabinoidTable header={'Cannabis Compounds'} eventGroupToTrigger={'compounds'} />
            <AromaTable header={'Aroma Table'} eventGroupToTrigger={'compounds'} />
            <PubChemListCard header={'PUBCHEM - Component/Substances List'} eventGroupToTrigger={'compounds'} />
            <PubChemTableCard header={'PUBCHEM - Properties'} storageValue={"Properties"} eventGroupToTrigger={'compounds'} />
            <ChemSpiderTableCard header={'ChemSpider - Components'} eventGroupToTrigger={'compounds'} />
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="compounds"/>
        </div>
        <div className="col-3 col-sm-3">
            <CompoundCard header={'Compound'} eventGroupToTrigger={'compounds'} />
            <CannabinoidCard header={'Cannabis Compound'} eventGroupToTrigger={'compounds'} />
            <AromaCard header={'Aroma'} eventGroupToTrigger={'compounds'} />
            <CannabisDBCard header={'Cannabis DB'} eventGroupToTrigger={'compounds'} />
            <PubchemCard header={'PUBCHEM Properties'} eventGroupToTrigger={'compounds'} />
            <ChemSpiderCard header={'ChemSpider Properties'} eventGroupToTrigger={'compounds'} />
        </div>
    </div>
);

export default TabPanelContentCompounds;
